const styles = {
  card: {
    flex: 1,
    height: '70vh',
    display: 'flex',
    flexDirection: 'column',
  },
  cardContainer: {
    overflowY: 'auto',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  loader: {
    zIndex: (theme) => theme.zIndex.modal + 1,
    color: '#fff',
    backdropFilter: 'blur(2px)',
    transition: 'opacity 0.3s ease-in-out',
  },
};

export default styles;
